@use '~/theme/theme' as *;

.table {
  width: 100%;
  border-collapse: collapse;
  break-inside: auto;

  tr {
    break-inside: avoid;
    break-after: auto;
  }
}
